import {ICustomerDeletionReason} from './Interface/ICustomer';

type BuildType = 'STAGING' | 'UAT' | 'PRODUCTION' | 'DEV';
type StoreLocation = 'SG' | 'ZRH';
export type SiteLang = 'en' | 'de';

let buildType: BuildType = 'PRODUCTION';
let storeLocation: StoreLocation = 'SG';

export const isProductionMode = () => {
  return buildType === 'PRODUCTION';
};
export const getBuildType = () => {
  return buildType;
};

export const getStoreLocation = () => {
  return storeLocation;
};

export const getProxyStoreUrl = () => {
  return storeLocation === 'ZRH' ? 'zrh.' : '';
};

let PRODUCTION_MODE = true;

const PRODUCTION_URL = {
  SG: 'https://portal.wine.delivery/',
  ZRH: 'https://portal.zrh.wine.delivery/',
};
const DEV_URL = {
  SG: 'https://portal.dev.winedelivery.tech/',
  ZRH: 'https://portal.zrh.dev.winedelivery.tech/',
};
const UAT_URL = {
  SG: 'https://portal.uat.winedelivery.tech/',
  ZRH: 'https://portal.zrh.uat.winedelivery.tech/',
};
const STAGING_URL = {
  SG: 'https://staging.winedelivery.tech/',
  ZRH: 'https://staging.zrh.winedelivery.tech/',
};

const STRIPE_STAGING_KEY = `pk_test_gaxmpw1lh99dkEr9CA4aT6Z9`;
const STRIPE_STAGING_MERCHANT_APPLE = `merchant.delivery.wine.staging.applepay`;
const STRIPE_STAGING_MERCHANT_GOOGLE = `3545-4736-5071`;

const STRIPE_PROD_KEY = `pk_live_HZy4QdwiYbLCj3cpeJoxu4Jn`;
const STRIPE_PROD_MERCHANT_APPLE = `merchant.delivery.wine.applepay`;
const STRIPE_PROD_MERCHANT_GOOGLE = `14259628497936850186`;

const FACEBOOK_APP_ID_PRODUCTION = 880348405389195;
const FACEBOOK_APP_ID_UAT = 530957833992783;

const FACEBOOK_PAGE_ID_PRODUCTION = '1020955368026192';

const FACEBOOK_PAGE_ID_UAT = '338377453446387';

const LINKEDIN_CLIENT_ID = '75st1qmxc0dd7a';

const LINKEDIN_KEY = 'vyOWNZWLMUqOfrbp';

// export const GOOGLE_ANALYTIC_DEV_ID = 'UA-129446471-1';
export const GOOGLE_ANALYTIC_DEV_ID = 'G-4THRHM6SB9';

// export const GOOGLE_ANALYTIC_PROD_ID = 'UA-79001687-1';
export const GOOGLE_ANALYTIC_PROD_ID = 'G-MMFW5F7B7D';

const RECAPTCHA_UAT_SITE_KEY = '6LdJkPcUAAAAAOVXoBaYEDQsXs-kYyx83K09RWw_';
const RECAPTCHA_UAT_SECRET_KEY = '6LdJkPcUAAAAALFZec4rSmoQrm0A1lNP90_0XJ0V';
const RECAPTCHA_DEV_SITE_KEY = '6LfDkPcUAAAAAGH_12AF6Nfk4_ZyNPgj-76A8Qz6';
const RECAPTCHA_DEV_SECRET_KEY = '6LfDkPcUAAAAAOw9qX8e2hKXzm_ig-d_K-nqjb-D';
const RECAPTCHA_PRODUCTION_SITE_KEY = '6LeSg_cUAAAAAGEY2w3RZwwIPhm9Wn_JKzDd7qz7';
const RECAPTCHA_PRODUCTION_SECRET_KEY = '6LeSg_cUAAAAAFbaZyd_jbrIFyRKudXIAfU1aHIQ';

const HOTJAR_VERSION = 6;
const HOTJAR_ID_PRODUCTION = '2177428';
const HOTJAR_ID_DEV = '2181125';
const HOTJAR_ID_UAT = '2181121';

const GTM_ID_PRODUCTION = 'GTM-PP9GTGB';
const GTM_ID_UAT = 'GTM-KVWVJJ2';

const CODE_PUSH_KEY = {
  ios: {
    production: {
      SG: '9HaC8t_Q1PB1T32hQrdQXSWiZ5qZHybRLilkH7',
      ZRH: 'j7puhoQJ4XWNLmHPxx07cN97yQvC0-K0DfZfk',
    },
    dev: {
      SG: 'e2wPYXU8CrLHBAv1-R-NEu_G74cpByaa_loom',
      ZRH: '9VGfCaEY1ytHECKZJugVdmpnnnIYEnqUbgUpL',
    },
    uat: {
      SG: '3RNM3HdIyGstc0_tonc0n1dEQC7a65f37261-7511-48fa-beb0-66ee31703375',
      ZRH: 'MhT5ncW21TJ0YS-gXcji-hwFJioo4R6LUdqm-',
    },
    staging: {
      SG: 'XqaaAFBoBFzXWSjDyXoXyqV1JvvMH1CLieJrQ',
      ZRH: '',
    },
  },
  android: {
    production: {
      SG: 'hLA2VGU9Wq-yNwMvAK3IQnmu-fhuB1gGHHZB7',
      ZRH: 'Jrl3kCHtn2hShI8hn98eT3nB3qYbi2ivz3Sja',
    },
    dev: {
      SG: '4sI09YvG1lvp2_AJEcKHFZvTeV7nrJ-WXjFMV',
      ZRH: 'gE88r1A0CPflEaujPAANsbbmdP9K-ZwP9u8C_',
    },
    uat: {
      SG: 'j4lMOAZCj0Edx0r-S2M6Szp1WmAYHJY5KHWB7',
      ZRH: 'uPyFiG5G-twKsGlLwKdpgf776YdVGyi0TfMtA',
    },
    staging: {
      SG: 'cOozLWkJZjXM0byLOeebmbrMUtxkHk1GHHbSm',
      ZRH: '',
    },
  },
};

const LOGISTICS_CODE_PUSH_KEY = {
  ios: {
    production: {
      SG: 'EK5E_z3AsiGnkm9VG2OPYzAJGgGMgOeYqi7WQ',
      ZRH: 'GBPgvaO2J_IAJB6oFNKodxYp7FIpnUbpekM51',
    },
    dev: {
      SG: 'BIEIH81JTTJf4HbhXn64EjzAabscYGXQtihk4',
      ZRH: 'BXlmkSZ5wcrvB2iA1jPiq1QBb8nt3SHHYXFSD',
    },
    uat: {
      SG: 'nCIEaec9I0iG5vfLDWXK2RPtyp-2OJJIh-TYs',
      ZRH: 'AS2-2rjJDkHZqukAWntEQiKCfGcVIyrDT1oqo',
    },
    staging: {
      SG: '6jW7KE83omCkBe8I5BfOLKuDLe18xGJBDHc8F',
      ZRH: '',
    },
  },
  android: {
    production: {
      SG: 'QN6_0g2nyicmNOVp9mg5TpK-Cz4ih6AiR7dE7',
      ZRH: 'Yf7sIeTnUluzn4v0A8bgJYTgo9t2rlAtHpBbO',
    },
    dev: {
      SG: 'MVdVSgzToHY2x1wuQ05Aas5IOTSLouvLd3SUS',
      ZRH: 'isgWNPdTlvsGQ4pOyAt12H3ItOfrLH6WmYPj9',
    },
    uat: {
      SG: 'Q9lZd29zWg6cLHEkAVtlbz_IMo7X7A1HayTZO',
      ZRH: 'ZcoJ7z1AWHGrr3CPyF_DnEtoneb2MkS6d3oeN',
    },
    staging: {
      SG: '2ltqRnb18z0X8LScyk8m2T1AyF1QvsM_ZJ3fE',
      ZRH: '',
    },
  },
};

let FACEBOOK_APP_ID;

let BACK_END_URL;

let STRIPE_PUBLIC_KEY;

let APPLE_PAY_MERCHANT_ID;

let GOOGLE_PAY_MERCHANT_ID;

let MAGENTO_API_URL;

let IMAGE_PREFIX;

let CODE_PUSH_DEPLOYMENT_KEY;

let WDDRIVER_CODE_PUSH_DEPLOYMENT_KEY;

let WEB_BASE_URL = `https://${getProxyStoreUrl()}wine.delivery/`;

let FACEBOOK_PAGE_ID;

let RECAPTCHA_SITE_KEY;

let HOTJAR_ID;

let GTM_ID;

export const INSTAGRAM_URL = 'https://www.instagram.com/sg.wine.delivery/';

export const FACEBOOK_PAGE_URL = 'https://www.facebook.com/sg.wine.delivery';

export const getFacebookPageId = () => {
  return FACEBOOK_PAGE_ID;
};
export const getImageS3Url = () => {
  switch (getBuildType()) {
    case 'PRODUCTION': {
      return 'https://image.wine.delivery/';
    }
    case 'DEV': {
      return 'https://image.dev.winedelivery.tech/';
    }
    case 'UAT': {
      return 'https://image.uat.winedelivery.tech/';
    }
    case 'STAGING': {
      return 'https://image.uat.winedelivery.tech/';
    }
  }
};
export const getLinkedinClientId = () => {
  return LINKEDIN_CLIENT_ID;
};
export const getBackEndURL = () => {
  return BACK_END_URL;
};

export const getLambdaApiURL = () => {
  return (getPlatform() === 'web' ? '/' : getWebBaseUrl()) + `${getBuildType().toLowerCase()}/`;
};

export const getStripePublicKey = () => {
  return STRIPE_PUBLIC_KEY;
};

export const getApplePaymentMerchantId = () => {
  return APPLE_PAY_MERCHANT_ID;
};

export const getGooglePaymentMerchantId = () => {
  return GOOGLE_PAY_MERCHANT_ID;
};

export const getMagentoApiUrl = () => {
  return MAGENTO_API_URL;
};

export const getImagePrefix: () => string = () => {
  return IMAGE_PREFIX;
};

export const getFacebookAppId: () => string = () => {
  return FACEBOOK_APP_ID;
};

export const getRecaptchaSiteKey: () => string = () => {
  return RECAPTCHA_SITE_KEY;
};

export const getHotjarKey = () => {
  return {
    id: HOTJAR_ID,
    version: HOTJAR_VERSION,
  };
};

export const getGTMID = () => {
  return GTM_ID;
};

export const getWebBaseUrl: () => string = () => {
  // @ts-ignore
  // if (typeof __DEV__ !== 'undefined' && getBuildType() === 'PRODUCTION' && getPlatform() === 'web') {
  //   return 'https://dev.winedelivery.tech/';
  // }
  // if (
  //   // @ts-ignore
  //   process &&
  //   // @ts-ignore
  //   process.env.NODE_ENV !== 'production' &&
  //   (getPlatform() === 'web' || getPlatform() === 'server_render')
  // ) {
  //   return 'https://localhost:3000/';
  // }
  return WEB_BASE_URL;
};

export const getLinkedinKey = () => {
  return LINKEDIN_KEY;
};

export type Platform = 'ios' | 'android' | 'windows' | 'web' | 'server_render' | 'macos';
let PLATFORM: Platform;
export const getDeploymentKey = (platform: Platform, buildType?: string, storeLocation?: StoreLocation) => {
  let key = CODE_PUSH_DEPLOYMENT_KEY;
  PLATFORM = platform;
  if (buildType) {
    if (platform === 'ios') {
      switch (buildType) {
        case 'PRODUCTION': {
          key = CODE_PUSH_KEY.ios.production[storeLocation];
          break;
        }
        case 'DEV': {
          key = CODE_PUSH_KEY.ios.dev[storeLocation];
          break;
        }
        case 'UAT': {
          key = CODE_PUSH_KEY.ios.uat[storeLocation];
          break;
        }
        case 'STAGING': {
          key = CODE_PUSH_KEY.ios.staging[storeLocation];
          break;
        }
      }
    } else if (platform === 'android') {
      switch (buildType) {
        case 'PRODUCTION': {
          key = CODE_PUSH_KEY.android.production[storeLocation];
          break;
        }
        case 'UAT': {
          key = CODE_PUSH_KEY.android.uat[storeLocation];
          break;
        }
        case 'STAGING': {
          key = CODE_PUSH_KEY.android.staging[storeLocation];
          break;
        }
        case 'DEV': {
          key = CODE_PUSH_KEY.android.dev[storeLocation];
          break;
        }
      }
    }
  }
  return key;
};

export const getWDDriverDeploymentKey = (platform: Platform, buildType?: string, storeLocation?: StoreLocation) => {
  let key = WDDRIVER_CODE_PUSH_DEPLOYMENT_KEY;
  PLATFORM = platform;
  if (buildType) {
    if (platform === 'ios') {
      switch (buildType) {
        case 'PRODUCTION': {
          key = LOGISTICS_CODE_PUSH_KEY.ios.production[storeLocation];
          break;
        }
        case 'DEV': {
          key = LOGISTICS_CODE_PUSH_KEY.ios.dev[storeLocation];
          break;
        }
        case 'UAT': {
          key = LOGISTICS_CODE_PUSH_KEY.ios.uat[storeLocation];
          break;
        }
        case 'STAGING': {
          key = LOGISTICS_CODE_PUSH_KEY.ios.staging[storeLocation];
          break;
        }
      }
    } else if (platform === 'android') {
      switch (buildType) {
        case 'PRODUCTION': {
          key = LOGISTICS_CODE_PUSH_KEY.android.production[storeLocation];
          break;
        }
        case 'UAT': {
          key = LOGISTICS_CODE_PUSH_KEY.android.uat[storeLocation];
          break;
        }
        case 'STAGING': {
          key = LOGISTICS_CODE_PUSH_KEY.android.staging[storeLocation];
          break;
        }
        case 'DEV': {
          key = LOGISTICS_CODE_PUSH_KEY.android.dev[storeLocation];
          break;
        }
      }
    }
  }
  return key;
};

export const getPlatform: () => Platform = () => {
  return PLATFORM;
};

export const initWDConfig = (
  platform: Platform,
  _buildType: 'STAGING' | 'UAT' | 'PRODUCTION' | 'DEV',
  _storeLocation: StoreLocation,
) => {
  buildType = _buildType;
  storeLocation = _storeLocation;
  PLATFORM = platform;
  if (platform === 'android' || platform === 'ios' || platform === 'server_render') {
    switch (_buildType) {
      case 'PRODUCTION': {
        PRODUCTION_MODE = true;
        BACK_END_URL = PRODUCTION_URL[storeLocation];
        STRIPE_PUBLIC_KEY = STRIPE_PROD_KEY;
        APPLE_PAY_MERCHANT_ID = STRIPE_PROD_MERCHANT_APPLE;
        GOOGLE_PAY_MERCHANT_ID = STRIPE_PROD_MERCHANT_GOOGLE;
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_PRODUCTION;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}wine.delivery/`;
        GTM_ID = GTM_ID_PRODUCTION;
        break;
      }
      case 'DEV': {
        PRODUCTION_MODE = false;
        BACK_END_URL = DEV_URL[storeLocation];
        STRIPE_PUBLIC_KEY = STRIPE_STAGING_KEY;
        APPLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_APPLE;
        GOOGLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_GOOGLE;
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_UAT;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}dev.winedelivery.tech/`;
        GTM_ID = GTM_ID_UAT;
        break;
      }
      case 'UAT': {
        PRODUCTION_MODE = false;
        BACK_END_URL = UAT_URL[storeLocation];
        STRIPE_PUBLIC_KEY = STRIPE_STAGING_KEY;
        APPLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_APPLE;
        GOOGLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_GOOGLE;
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_UAT;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}uatv2.winedelivery.tech/`;
        GTM_ID = GTM_ID_UAT;
        break;
      }
      case 'STAGING': {
        PRODUCTION_MODE = false;
        BACK_END_URL = STAGING_URL[storeLocation] + '';
        STRIPE_PUBLIC_KEY = STRIPE_STAGING_KEY + '';
        APPLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_APPLE + '';
        GOOGLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_GOOGLE + '';
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_UAT;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}staging.winedelivery.tech/`;
        GTM_ID = GTM_ID_UAT;
        break;
      }
    }
    CODE_PUSH_DEPLOYMENT_KEY = getDeploymentKey(platform, _buildType, _storeLocation);
    WDDRIVER_CODE_PUSH_DEPLOYMENT_KEY = getWDDriverDeploymentKey(platform, _buildType, _storeLocation);
    MAGENTO_API_URL = BACK_END_URL;

    IMAGE_PREFIX = BACK_END_URL + 'media/catalog/product/';
  } else if (platform === 'web') {
    switch (_buildType) {
      case 'PRODUCTION': {
        PRODUCTION_MODE = true;
        BACK_END_URL = '/production/';
        STRIPE_PUBLIC_KEY = STRIPE_PROD_KEY;
        APPLE_PAY_MERCHANT_ID = STRIPE_PROD_MERCHANT_APPLE;
        GOOGLE_PAY_MERCHANT_ID = STRIPE_PROD_MERCHANT_GOOGLE;
        IMAGE_PREFIX = 'https://portal.wine.delivery/media/catalog/product/';
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_PRODUCTION;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}wine.delivery/`;
        FACEBOOK_PAGE_ID = FACEBOOK_PAGE_ID_PRODUCTION;
        RECAPTCHA_SITE_KEY = RECAPTCHA_PRODUCTION_SITE_KEY;
        HOTJAR_ID = HOTJAR_ID_PRODUCTION;
        GTM_ID = GTM_ID_PRODUCTION;
        break;
      }
      case 'DEV': {
        PRODUCTION_MODE = false;
        BACK_END_URL = '/dev/';
        STRIPE_PUBLIC_KEY = STRIPE_STAGING_KEY;
        APPLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_APPLE;
        GOOGLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_GOOGLE;
        IMAGE_PREFIX = 'https://portal.dev.winedelivery/media/catalog/product/';
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_UAT;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}dev.winedelivery.tech/`;
        FACEBOOK_PAGE_ID = FACEBOOK_PAGE_ID_UAT;
        RECAPTCHA_SITE_KEY = RECAPTCHA_UAT_SITE_KEY;
        HOTJAR_ID = HOTJAR_ID_DEV;
        GTM_ID = GTM_ID_UAT;
        break;
      }
      case 'UAT': {
        PRODUCTION_MODE = false;
        BACK_END_URL = '/uat/';
        STRIPE_PUBLIC_KEY = STRIPE_STAGING_KEY;
        APPLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_APPLE;
        GOOGLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_GOOGLE + '';
        IMAGE_PREFIX = 'https://portal.uat.winedelivery.tech/media/catalog/product/';
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_UAT;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}uatv2.winedelivery.tech/`;
        FACEBOOK_PAGE_ID = FACEBOOK_PAGE_ID_UAT;
        RECAPTCHA_SITE_KEY = RECAPTCHA_UAT_SITE_KEY;
        HOTJAR_ID = HOTJAR_ID_UAT;
        GTM_ID = GTM_ID_UAT;
        break;
      }
      case 'STAGING': {
        PRODUCTION_MODE = false;
        BACK_END_URL = '/staging/';
        STRIPE_PUBLIC_KEY = STRIPE_STAGING_KEY + '';
        APPLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_APPLE + '';
        GOOGLE_PAY_MERCHANT_ID = STRIPE_STAGING_MERCHANT_GOOGLE + '';
        IMAGE_PREFIX = 'https://staging.winedelivery.tech/media/catalog/product/';
        FACEBOOK_APP_ID = FACEBOOK_APP_ID_UAT;
        WEB_BASE_URL = `https://${getProxyStoreUrl()}dev.winedelivery.tech/`;
        GTM_ID = GTM_ID_UAT;
        break;
      }
    }
    MAGENTO_API_URL = BACK_END_URL;
  }
};

export const GOOGLE_VISION = 'AIzaSyDyGK70-XuiB_lBmtOHd-V8tws7Tzl81qw';

export const CURRENT_VERSION = 77;

export const STAFF_PICK_RECOMMENDATION_ID = '160';

export const PASSWORD_MIN_CHARS = 6;

export const PASSWORD_MIN_CLASSES = 2;

export const GOOGLE_AUTH_APP_ID_IOS = '722795265254-071qt27reo3n25p42nk7tsm5vmglbb4g.apps.googleusercontent.com';

export const GOOGLE_AUTH_APP_ID_WEB = '722795265254-put5jsh6mgp605k9talmvt5tg320nae9.apps.googleusercontent.com';

export const WINE_PAGE_SIZE = 36;

export const NODE_SERVER_URL = 'https://5hnga049w7.execute-api.ap-southeast-1.amazonaws.com/dev/';

export const HARD_CODED_COUNTRIES = {
  Afghanistan: 'AF',
  'Aland Islands': 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua and Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bonaire, Saint Eustatius and Saba ': 'BQ',
  'Bosnia and Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'British Virgin Islands': 'VG',
  Brunei: 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  Croatia: 'HR',
  Cuba: 'CU',
  Curacao: 'CW',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  'Democratic Republic of the Congo': 'CD',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  'East Timor': 'TL',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island and McDonald Islands': 'HM',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Iran: 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle of Man': 'IM',
  Israel: 'IL',
  Italy: 'IT',
  'Ivory Coast': 'CI',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  Kosovo: 'XK',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  Laos: 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Macedonia: 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  Micronesia: 'FM',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'North Korea': 'KP',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  'Palestinian Territory': 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  'Republic of the Congo': 'CG',
  Reunion: 'RE',
  Romania: 'RO',
  Russia: 'RU',
  Rwanda: 'RW',
  'Saint Barthelemy': 'BL',
  'Saint Helena': 'SH',
  'Saint Kitts and Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin': 'MF',
  'Saint Pierre and Miquelon': 'PM',
  'Saint Vincent and the Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome and Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  'Sint Maarten': 'SX',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia and the South Sandwich Islands': 'GS',
  'South Korea': 'KR',
  'South Sudan': 'SS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard and Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  Syria: 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Thailand: 'TH',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks and Caicos Islands': 'TC',
  Tuvalu: 'TV',
  'U.S. Virgin Islands': 'VI',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  'United States Minor Outlying Islands': 'UM',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  Vatican: 'VA',
  Venezuela: 'VE',
  Vietnam: 'VN',
  'Wallis and Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};

export const COUNTRY_AREA_CODE = {
  BD: '880',
  BE: '32',
  BF: '226',
  BG: '359',
  BA: '387',
  BB: '+1-246',
  WF: '681',
  BL: '590',
  BM: '+1-441',
  BN: '673',
  BO: '591',
  BH: '973',
  BI: '257',
  BJ: '229',
  BT: '975',
  JM: '+1-876',
  BV: '',
  BW: '267',
  WS: '685',
  BQ: '599',
  BR: '55',
  BS: '+1-242',
  JE: '+44-1534',
  BY: '375',
  BZ: '501',
  RU: '7',
  RW: '250',
  RS: '381',
  TL: '670',
  RE: '262',
  TM: '993',
  TJ: '992',
  RO: '40',
  TK: '690',
  GW: '245',
  GU: '+1-671',
  GT: '502',
  GS: '',
  GR: '30',
  GQ: '240',
  GP: '590',
  JP: '81',
  GY: '592',
  GG: '+44-1481',
  GF: '594',
  GE: '995',
  GD: '+1-473',
  GB: '44',
  GA: '241',
  SV: '503',
  GN: '224',
  GM: '220',
  GL: '299',
  GI: '350',
  GH: '233',
  OM: '968',
  TN: '216',
  JO: '962',
  HR: '385',
  HT: '509',
  HU: '36',
  HK: '852',
  HN: '504',
  HM: ' ',
  VE: '58',
  PR: '+1-787 and 1-939',
  PS: '970',
  PW: '680',
  PT: '351',
  SJ: '47',
  PY: '595',
  IQ: '964',
  PA: '507',
  PF: '689',
  PG: '675',
  PE: '51',
  PK: '92',
  PH: '63',
  PN: '870',
  PL: '48',
  PM: '508',
  ZM: '260',
  EH: '212',
  EE: '372',
  EG: '20',
  ZA: '27',
  EC: '593',
  IT: '39',
  VN: '84',
  SB: '677',
  ET: '251',
  SO: '252',
  ZW: '263',
  SA: '966',
  ES: '34',
  ER: '291',
  ME: '382',
  MD: '373',
  MG: '261',
  MF: '590',
  MA: '212',
  MC: '377',
  UZ: '998',
  MM: '95',
  ML: '223',
  MO: '853',
  MN: '976',
  MH: '692',
  MK: '389',
  MU: '230',
  MT: '356',
  MW: '265',
  MV: '960',
  MQ: '596',
  MP: '+1-670',
  MS: '+1-664',
  MR: '222',
  IM: '+44-1624',
  UG: '256',
  TZ: '255',
  MY: '60',
  MX: '52',
  IL: '972',
  FR: '33',
  IO: '246',
  SH: '290',
  FI: '358',
  FJ: '679',
  FK: '500',
  FM: '691',
  FO: '298',
  NI: '505',
  NL: '31',
  NO: '47',
  NA: '264',
  VU: '678',
  NC: '687',
  NE: '227',
  NF: '672',
  NG: '234',
  NZ: '64',
  NP: '977',
  NR: '674',
  NU: '683',
  CK: '682',
  XK: '',
  CI: '225',
  CH: '41',
  CO: '57',
  CN: '86',
  CM: '237',
  CL: '56',
  CC: '61',
  CA: '1',
  CG: '242',
  CF: '236',
  CD: '243',
  CZ: '420',
  CY: '357',
  CX: '61',
  CR: '506',
  CW: '599',
  CV: '238',
  CU: '53',
  SZ: '268',
  SY: '963',
  SX: '599',
  KG: '996',
  KE: '254',
  SS: '211',
  SR: '597',
  KI: '686',
  KH: '855',
  KN: '+1-869',
  KM: '269',
  ST: '239',
  SK: '421',
  KR: '82',
  SI: '386',
  KP: '850',
  KW: '965',
  SN: '221',
  SM: '378',
  SL: '232',
  SC: '248',
  KZ: '7',
  KY: '+1-345',
  SG: '65',
  SE: '46',
  SD: '249',
  DO: '+1-809 and 1-829',
  DM: '+1-767',
  DJ: '253',
  DK: '45',
  VG: '+1-284',
  DE: '49',
  YE: '967',
  DZ: '213',
  US: '1',
  UY: '598',
  YT: '262',
  UM: '1',
  LB: '961',
  LC: '+1-758',
  LA: '856',
  TV: '688',
  TW: '886',
  TT: '+1-868',
  TR: '90',
  LK: '94',
  LI: '423',
  LV: '371',
  TO: '676',
  LT: '370',
  LU: '352',
  LR: '231',
  LS: '266',
  TH: '66',
  TF: '',
  TG: '228',
  TD: '235',
  TC: '+1-649',
  LY: '218',
  VA: '379',
  VC: '+1-784',
  AE: '971',
  AD: '376',
  AG: '+1-268',
  AF: '93',
  AI: '+1-264',
  VI: '+1-340',
  IS: '354',
  IR: '98',
  AM: '374',
  AL: '355',
  AO: '244',
  AQ: '',
  AS: '+1-684',
  AR: '54',
  AU: '61',
  AT: '43',
  AW: '297',
  IN: '91',
  AX: '+358-18',
  AZ: '994',
  IE: '353',
  ID: '62',
  UA: '380',
  QA: '974',
  MZ: '258',
};

export const AVAILABLE_SHIPPING_COUNTRIES = ['Singapore'];

export const PUBLIC_HOLIDAYS = [
  '2022-01-01',
  '2022-02-01',
  '2022-02-02',
  '2022-04-15',
  '2022-05-01',
  '2022-05-03',
  '2022-05-15',
  '2022-07-10',
  '2022-08-09',
  '2022-10-24',
  '2022-12-25',
];

export const INTERNAL_USERS = [
  'potato@acalution.com',
  'mark.lauw@acalution.com',
  'andy.wijaya@acalution.com',
  'mark.457240@gmail.com',
  'natanaelgunawan7@gmail.com',
  'samudra@acalution.com',
];

export const getSearchFilterRanking = (name: string) => {
  if (name === 'TYPE') {
    return 1;
  }
  if (name === 'GRAPE VARIETIES') {
    return 2;
  }
  if (name === 'COUNTRY') {
    return 3;
  }
  if (name === 'REGION') {
    return 4;
  }
  return 10;
};

export const MAX_WINE_PRICE = 600;

export const MAXIMUM_SHOW_STOCK_AMOUNT = 3;

export const GENERAL_CACHE_EXPIRE_MINUTES = 5;

export const LOADING_MESSAGES = [
  // "Picking grapes...",
  // "Brewing wine...",
  // "Wiping wine bottles...",
  // "Loading wine to delivery jet...",
  // "Conjuring wine with fairy dust...",
  // "Seeking approval from wine wizard...",
  // "Reheating coffee...",
  // "Compiling source code...",
  // "Dipping cookies to milk...",
  // "Bending spacetime..."
  'Processing...',
];

export const BAD_WORDS = `2 girls 1 cup,2g1c,4r5e,5h1t,5hit,a$$,a$$hole,a_s_s,a2m,a54,a55,a55hole,acrotomophilia,aeolus,ahole,alabama hot pocket,alaskan pipeline,anal,anal impaler,anal leakage,analprobe,anilingus,anus,apeshit,ar5e,areola,areole,arian,arrse,arse,arsehole,aryan,ass,ass fuck,ass hole,assbag,assbandit,assbang,assbanged,assbanger,assbangs,assbite,assclown,asscock,asscracker,asses,assface,assfaces,assfuck,assfucker,ass-fucker,assfukka,assgoblin,assh0le,asshat,ass-hat,asshead,assho1e,asshole,assholes,asshopper,ass-jabber,assjacker,asslick,asslicker,assmaster,assmonkey,assmucus,assmunch,assmuncher,assnigger,asspirate,ass-pirate,assshit,assshole,asssucker,asswad,asswhole,asswipe,asswipes,auto erotic,autoerotic,axwound,azazel,azz,b!tch,b00bs,b17ch,b1tch,babeland,baby batter,baby juice,ball gag,ball gravy,ball kicking,ball licking,ball sack,ball sucking,ballbag,balls,ballsack,bampot,bang (one's) box,bangbros,bareback,barely legal,barenaked,barf,bastard,bastardo,bastards,bastinado,batty boy,bawdy,bbw,bdsm,beaner,beaners,beardedclam,beastial,beastiality,beatch,beaver,beaver cleaver,beaver lips,beef curtain,beef curtains,beeyotch,bellend,bender,beotch,bescumber,bestial,bestiality,bi+ch,biatch,big black,big breasts,big knockers,big tits,bigtits,bimbo,bimbos,bint,birdlock,bitch,bitch tit,bitchass,bitched,bitcher,bitchers,bitches,bitchin,bitching,bitchtits,bitchy,black cock,blonde action,blonde on blonde action,bloodclaat,bloody,bloody hell,blow job,blow me,blow mud,blow your load,blowjob,blowjobs,blue waffle,blumpkin,bod,bodily,boink,boiolas,bollock,bollocks,bollok,bollox,bondage,boned,boner,boners,bong,boob,boobies,boobs,booby,booger,bookie,boong,booobs,boooobs,booooobs,booooooobs,bootee,bootie,booty,booty call,boozer,bosom,bosomy,breasts,Breeder,brotherfucker,brown showers,brunette action,buceta,bugger,bukkake,bullshit,bulldyke,bullet vibe,bullshits,bullshitted,bullturds,bum,bum boy,bumblefuck,bumclat,bummer,buncombe,bung,bung hole,bunghole,bunny fucker,bust a load,busty,butt,butt fuck,butt plug,buttcheeks,buttfuck,buttfucka,buttfucker,butthole,buttmuch,buttmunch,butt-pirate,buttplug,c.0.c.k,c.o.c.k.,c.u.n.t,c0ck,c-0-c-k,c0cksucker,caca,cacafuego,cahone,camel toe,cameltoe,camgirl,camslut,camwhore,carpet muncher,carpetmuncher,cawk,cervix,chesticle,chi-chi man,chick with a dick,child-fucker,chinc,chincs,chink,chinky,choad,choade,choc ice,chocolate rosebuds,chode,chodes,chota bags,cipa,circlejerk,cl1t,cleveland steamer,climax,clit,clit licker,clitface,clitfuck,clitoris,clitorus,clits,clitty,clitty litter,clover clamps,clunge,clusterfuck,cnut,cocain,cocaine,coccydynia,cock,c-o-c-k,cock pocket,cock snot,cock sucker,cockass,cockbite,cockblock,cockburger,cockeye,cockface,cockfucker,cockhead,cockholster,cockjockey,cockknocker,cockknoker,Cocklump,cockmaster,cockmongler,cockmongruel,cockmonkey,cockmunch,cockmuncher,cocknose,cocknugget,cocks,cockshit,cocksmith,cocksmoke,cocksmoker,cocksniffer,cocksuck,cocksucked,cocksucker,cock-sucker,cocksuckers,cocksucking,cocksucks,cocksuka,cocksukka,cockwaffle,coffin dodger,coital,cok,cokmuncher,coksucka,commie,condom,coochie,coochy,coon,coonnass,coons,cooter,cop some wood,coprolagnia,coprophilia,corksucker,cornhole,corp whore,corpulent,cox,crabs,crack,cracker,crackwhore,crap,crappy,creampie,cretin,crikey,cripple,crotte,cum,cum chugger,cum dumpster,cum freak,cum guzzler,cum guzzler,cumbubble,cumdump,cumdumpster,cumguzzler,cumjockey,cummer,cummin,cumming,cums,cumshot,cumshots,cumslut,cumstain,cumtart,cunilingus,cunillingus,cunnie,cunnilingus,cunny,cunt,c-u-n-t,cunt hair,cuntass,cuntbag,cuntface,cunthole,cunthunter,cuntlick,cuntlicker,cuntlicking,cuntrag,cunts,cuntsicle,cuntslut,cunt-struck,cus,cut rope,cyalis,cyberfuc,cyberfuck,cyberfucked,cyberfucker,cyberfuckers,cyberfucking,d0ng,d0uch3,d0uche,d1ck,d1ld0,d1ldo,dago,dagos,dammit,damned,damnit,darkie,darn,date rape,daterape,dawgie-style,deep throat,deepthroat,deggo,dendrophilia,dick,dick head,dick hole,dick shy,dickbag,dickbeaters,dickdipper,dickface,dickflipper,dickfuck,dickfucker,dickhead,dickheads,dickhole,dickish,dick-ish,dickjuice,dickmilk,dickmonger,dickripper,dicks,dicksipper,dickslap,dick-sneeze,dicksucker,dicksucking,dicktickler,dickwad,dickweasel,dickweed,dickwhipper,dickwod,dickzipper,diddle,dike,dildo,dildos,diligaf,dillweed,dimwit,dingle,dingleberries,dingleberry,dink,dinks,dipship,dipshit,dirsa,dirty,dirty pillows,dirty sanchez,div,dlck,dog style,dog-fucker,doggie style,doggiestyle,doggie-style,doggin,dogging,doggy style,doggystyle,doggy-style,dolcett,domination,dominatrix,dommes,dong,donkey punch,donkeypunch,donkeyribber,doochbag,doofus,dookie,doosh,dopey,double dong,double penetration,Doublelift,douch3,douche,douchebag,douchebags,douche-fag,douchewaffle,douchey,dp action,dry hump,duche,dumass,dumb ass,dumbass,dumbasses,Dumbcunt,dumbfuck,dumbshit,dummy,dumshit,dvda,dyke,dykes,eat a dick,eat hair pie,eat my ass,ecchi,ejaculate,ejaculated,ejaculates,ejaculating,ejaculatings,ejaculation,ejakulate,erect,erection,erotic,erotism,escort,essohbee,eunuch,extacy,extasy,f u c k,f u c k e r,f.u.c.k,f_u_c_k,f4nny,facial,fack,fag,fagbag,fagfucker,fagg,fagged,fagging,faggit,faggitt,faggot,faggotcock,faggots,faggs,fagot,fagots,fags,fagtard,faig,faigt,fanny,fannybandit,fannyflaps,fannyfucker,fanyy,fart,fartknocker,fatass,fcuk,fcuker,fcuking,fecal,feck,fecker,feist,felch,felcher,felching,fellate,fellatio,feltch,feltcher,female squirting,femdom,fenian,fice,figging,fingerbang,fingerfuck,fingerfucked,fingerfucker,fingerfuckers,fingerfucking,fingerfucks,fingering,fist fuck,fisted,fistfuck,fistfucked,fistfucker,fistfuckers,fistfucking,fistfuckings,fistfucks,fisting,fisty,flamer,flange,flaps,fleshflute,flog the log,floozy,foad,foah,fondle,foobar,fook,fooker,foot fetish,footjob,foreskin,freex,frenchify,frigg,frigga,frotting,fubar,fuc,fuck,f-u-c-k,fuck buttons,fuck hole,Fuck off,fuck puppet,fuck trophy,fuck yo mama,fuck you,fucka,fuckass,fuck-ass,fuckbag,fuck-bitch,fuckboy,fuckbrain,fuckbutt,fuckbutter,fucked,fuckedup,fucker,fuckers,fuckersucker,fuckface,fuckhead,fuckheads,fuckhole,fuckin,fucking,fuckings,fuckingshitmotherfucker,fuckme,fuckmeat,fucknugget,fucknut,fucknutt,fuckoff,fucks,fuckstick,fucktard,fuck-tard,fucktards,fucktart,fucktoy,fucktwat,fuckup,fuckwad,fuckwhit,fuckwit,fuckwitt,fudge packer,fudgepacker,fudge-packer,fuk,fuker,fukker,fukkers,fukkin,fuks,fukwhit,fukwit,fuq,futanari,fux,fux0r,fvck,fxck,gae,gai,gang bang,gangbang,gang-bang,gangbanged,gangbangs,ganja,gash,gassy ass,gay,gay sex,gayass,gaybob,gaydo,gayfuck,gayfuckist,gaylord,gays,gaysex,gaytard,gaywad,gender bender,genitals,gey,gfy,ghay,ghey,giant cock,gigolo,ginger,gippo,girl on,girl on top,girls gone wild,git,glans,goatcx,goatse,god,god damn,godamn,godamnit,goddam,god-dam,goddammit,goddamn,goddamned,god-damned,goddamnit,godsdamn,gokkun,golden shower,goldenshower,golliwog,gonad,gonads,goo girl,gooch,goodpoop,gook,gooks,goregasm,gringo,grope,group sex,gspot,g-spot,gtfo,guido,guro,h0m0,h0mo,ham flap,hand job,handjob,hard core,hard on,hardcore,hardcoresex,he11,hebe,heeb,hemp,hentai,heroin,herp,herpes,herpy,heshe,he-she,hircismus,hitler,hiv,hoar,hoare,hobag,hoe,hoer,holy shit,hom0,homey,homo,homodumbshit,homoerotic,homoey,honkey,honky,hooch,hookah,hooker,hoor,hootch,hooter,hooters,hore,horniest,horny,hot carl,hot chick,hotsex,how to kill,how to murdep,how to murder,huge fat,hump,humped,humping,hun,hussy,hymen,iap,iberian slap,inbred,incest,injun,intercourse,jack off,jackass,jackasses,jackhole,jackoff,jack-off,jaggi,jagoff,jail bait,jailbait,jap,japs,jelly donut,jerk,jerk off,jerk0ff,jerkass,jerked,jerkoff,jerk-off,jigaboo,jiggaboo,jiggerboo,jism,jiz,jizm,jizm,jizz,jizzed,jock,juggs,jungle bunny,junglebunny,junkie,junky,kafir,kawk,kike,kikes,kill,kinbaku,kinkster,kinky,klan,knob,knob end,knobbing,knobead,knobed,knobend,knobhead,knobjocky,knobjokey,kock,kondum,kondums,kooch,kooches,kootch,kraut,kum,kummer,kumming,kums,kunilingus,kunja,kunt,kwif,kyke,l3i+ch,l3itch,labia,lameass,lardass,leather restraint,leather straight jacket,lech,lemon party,LEN,leper,lesbian,lesbians,lesbo,lesbos,lez,lezza/lesbo,lezzie,lmao,lmfao,loin,loins,lolita,looney,lovemaking,lube,lust,lusting,lusty,m0f0,m0fo,m45terbate,ma5terb8,ma5terbate,mafugly,make me come,male squirting,mams,masochist,massa,masterb8,masterbat*,masterbat3,masterbate,master-bate,masterbating,masterbation,masterbations,masturbate,masturbating,masturbation,maxi,mcfagget,menage a trois,menses,menstruate,menstruation,meth,m-fucking,mick,microphallus,middle finger,midget,milf,minge,minger,missionary position,mof0,mofo,mo-fo,molest,mong,moo moo foo foo,moolie,moron,mothafuck,mothafucka,mothafuckas,mothafuckaz,mothafucked,mothafucker,mothafuckers,mothafuckin,mothafucking,mothafuckings,mothafucks,mother fucker,motherfuck,motherfucka,motherfucked,motherfucker,motherfuckers,motherfuckin,motherfucking,motherfuckings,motherfuckka,motherfucks,mound of venus,mr hands,muff,muff diver,muff puff,muffdiver,muffdiving,munging,munter,murder,mutha,muthafecker,muthafuckker,muther,mutherfucker,n1gga,n1gger,naked,nambla,napalm,nappy,nawashi,nazi,nazism,need the dick,negro,neonazi,nig nog,nigaboo,nigg3r,nigg4h,nigga,niggah,niggas,niggaz,nigger,niggers,niggle,niglet,nig-nog,nimphomania,nimrod,ninny,ninnyhammer,nipple,nipples,nob,nob jokey,nobhead,nobjocky,nobjokey,nonce,nsfw images,nude,nudity,numbnuts,nut butter,nut sack,nutsack,nutter,nympho,nymphomania,octopussy,old bag,omg,omorashi,one cup two girls,one guy one jar,opiate,opium,orally,organ,orgasim,orgasims,orgasm,orgasmic,orgasms,orgies,orgy,ovary,ovum,ovums,p.u.s.s.y.,p0rn,paedophile,paki,panooch,pansy,pantie,panties,panty,pawn,pcp,pecker,peckerhead,pedo,pedobear,pedophile,pedophilia,pedophiliac,pee,peepee,pegging,penetrate,penetration,penial,penile,penis,penisbanger,penisfucker,penispuffer,perversion,phallic,phone sex,phonesex,phuck,phuk,phuked,phuking,phukked,phukking,phuks,phuq,piece of shit,pigfucker,pikey,pillowbiter,pimp,pimpis,pinko,piss,piss off,piss pig,pissed,pissed off,pisser,pissers,pisses,pissflaps,pissin,pissing,pissoff,piss-off,pisspig,playboy,pleasure chest,pms,polack,pole smoker,polesmoker,pollock,ponyplay,poof,poon,poonani,poonany,poontang,poop,poop 
chute,poopchute,Poopuncher,porch monkey,porchmonkey,porn,porno,pornography,pornos,pot,potty,prick,pricks,prickteaser,prig,prince albert piercing,prod,pron,prostitute,prude,psycho,pthc,pube,pubes,pubic,pubis,punani,punanny,punany,punkass,punky,punta,puss,pusse,pussi,pussies,pussy,pussy fart,pussy palace,pussylicking,pussypounder,pussys,pust,puto,queaf,queef,queer,queerbait,queerhole,queero,queers,quicky,quim,racy,raghead,raging boner,rape,raped,raper,rapey,raping,rapist,raunch,rectal,rectum,rectus,reefer,reetard,reich,renob,retard,retarded,reverse cowgirl,revue,rimjaw,rimjob,rimming,ritard,rosy palm,rosy palm and her 5 sisters,rtard,r-tard,rubbish,rump,rumprammer,ruski,rusty trombone,s hit,s&m,s.h.i.t.,s.o.b.,s_h_i_t,s0b,sadism,sadist,sambo,sand nigger,sandbar,Sandler,sandnigger,sanger,santorum,sausage queen,scag,scantily,scat,schizo,schlong,scissoring,screw,screwed,screwing,scroat,scrog,scrot,scrote,scrotum,scrud,scum,seaman,seamen,seduce,seks,semen,sex,sexo,sexual,sexy,sh!+,sh!t,sh1t,s-h-1-t,shag,shagger,shaggin,shagging,shamedame,shaved beaver,shaved pussy,shemale,shi+,shibari,shirt lifter,shit,s-h-i-t,shit ass,shit fucker,shitfucker,shitass,shitbag,shitbagger,shitblimp,shitbrains,shitbreath,shitcanned,shitcunt,shitdick,shite,shiteater,shited,shitey,shitface,shitfaced,shitfuck,shitfull,shithead,shitheads,shithole,shithouse,shiting,shitings,shits,shitspitter,shitstain,shitt,shitted,shitter,shitters,shittier,shittiest,shitting,shittings,shitty,shiz,shiznit,shota,shrimping,sissy,skag,skank,skeet,skullfuck,slag,slanteye,slave,sleaze,sleazy,slope,slut,slut bucket,slutbag,slutdumper,slutkiss,sluts,smartass,smartasses,smeg,smegma,smut,smutty,snatch,sniper,snowballing,snuff,s-o-b,sod off,sodom,sodomize,sodomy,son of a bitch,son of a motherless goat,son of a whore,son-of-a-bitch,souse,soused,spac,spade,sperm,spic,spick,spik,spiks,splooge,splooge moose,spooge,spook,spread legs,spunk,stfu,stiffy,stoned,strap on,strapon,strappado,strip,strip club,stroke,stupid,style doggy,suck,suckass,sucked,sucking,sucks,suicide girls,sultry women,sumofabiatch,swastika,swinger,t1t,t1tt1e5,t1tties,taff,taig,tainted love,taking the piss,tampon,tard,tart,taste my,tawdry,tea bagging,teabagging,teat,teets,teez,teste,testee,testes,testical,testicle,testis,threesome,throating,thrust,thug,thundercunt,tied up,tight white,tinkle,tit,tit wank,titfuck,titi,tities,tits,titt,tittie5,tittiefucker,titties,titty,tittyfuck,tittyfucker,tittywank,titwank,toke,tongue in a,toots,topless,tosser,towelhead,tramp,tranny,transsexual,trashy,tribadism,trumped,tub girl,tubgirl,turd,tush,tushy,tw4t,twat,twathead,twatlips,twats,twatty,twatwaffle,twink,twinkie,two fingers,two fingers with tongue,two girls one cup,twunt,twunter,ugly,unclefucker,undies,undressing,unwed,upskirt,urethra play,urinal,urine,urophilia,uterus,uzi,v14gra,v1gra,vag,vagina,vajayjay,va-j-j,valium,venus mound,veqtable,viagra,vibrator,violet wand,virgin,vixen,vjayjay,vomit,vorarephilia,voyeur,vulgar,vulva,w00se,wad,wang,wank,wanker,wankjob,wanky,wazoo,wedgie,weed,weenie,weewee,weiner,weirdo,wench,wet dream,wetback,wh0re,wh0reface,white power,whiz,whoar,whoralicious,whore,whorealicious,whorebag,whored,whoreface,whorehopper,whorehouse,whores,whoring,wigger,willies,willy,window licker,wiseass,wiseasses,wog,womb,wop,wrapping men,wrinkled starfish,wtf,xrated,x-rated,yaoi,yeasty,yellow showers,yid,yiffy,yobbo,zibbi,zoophilia,zubb,poop chute`;

export const WDExpressWording = {
  copies: 'copies',
  subCopies: 'subCopies',
  general: 'general',
  eligible: 'eligible',
  halfEligible: 'halfEligible',
  notEligible: 'notEligible',
};

export const accountDeletionReasons: ICustomerDeletionReason[] = [
  {
    value: '1',
    label: `I'm not using this account anymore`,
  },
  {
    value: '2',
    label: 'I have another account',
  },
  {
    value: '3',
    label: 'I want to create a new account',
  },
  {
    value: '4',
    label: 'Account security concerns',
  },
  {
    value: '5',
    label: 'Privacy concerns',
  },
  {
    value: '6',
    label: 'Imperfect experience / unresolved issue with Wine.Delivery',
  },
  {
    value: '7',
    label: 'I don’t want to provide a reason',
  },
];

export const SearchFilterPriority = {
  grapes: [
    'Cabernet Sauvignon',
    'Chardonnay',
    'Chenin Blanc',
    'Grenache/ Garnacha',
    'Merlot',
    'Nebbiolo',
    'Pinot Gris/ Grigio',
    'Pinot Noir',
    'Riesling',
    'Sangiovese',
    'Syrah/ Shiraz',
    'Tempranillo',
  ],
  country: [
    'France',
    'Italy',
    'Australia',
    'Spain',
    'New Zealand',
    'United Kingdom',
    'Chile',
    'Portugal',
    'South Africa',
    'Germany',
    'United States',
    'Japan',
  ],
};
